import { Component, OnInit } from '@angular/core';
import {CoefService} from '../../service/coef.service';

@Component({
  selector: 'app-doorleft-d',
  templateUrl: './door-left-d.component.html',
  styleUrls: ['./door-left-d.component.scss']
})
export class DoorleftDComponent implements OnInit {

  constructor(public coef: CoefService) { }

  ngOnInit() {
  }

}
